import LocationsTable from "../../components/tables/LocationsTable";
import JobSitesTable from "../../components/tables/JobSitesTable";
import { usePublicSiteId } from "../../contexts/PublicSiteContext";
import { isConstructionWalk } from "../../utils/publicSite";

export default function Locations() {
  const siteId = usePublicSiteId()

  return (
    <div className="w-full min-h-full overflow-auto h-full">
      {isConstructionWalk(siteId) ? <JobSitesTable /> : <LocationsTable />}
    </div>
  )
}
